<template>
  <tr class="even:bg-white odd:bg-gray-50">
    <td class="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900 tabular-nums">
      {{ productName }}
    </td>
    <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
      {{ reactionName }}
    </td>
    <td class="px-4 py-4 text-right">
      <div class="space-x-2 whitespace-nowrap">
        <AccProductReactionDeleteAction
          :acc-product-reaction="accProductReaction"
          @acc-product-reaction-deleted="onAccProductReactionDeleted"
        />
      </div>
    </td>
  </tr>
</template>

<script>
import AccProductReactionDeleteAction from './AccProductReactionDeleteAction.vue';

export default {
  components: {
    AccProductReactionDeleteAction,
  },
  props: {
    accProductReaction: {
      type: Object,
      required: true,
    },
  },
  computed: {
    productName() {
      return this.accProductReaction?.accProduct?.name || this.accountProductReaction.accProductId;
    },
    reactionName() {
      return (
        this.accProductReaction?.accProductReactionType?.name ||
        this.accountProductReaction.accProductReactionTypeId
      );
    },
  },
  methods: {
    onAccProductReactionDeleted(deletedAccProductReaction) {
      this.$emit('acc-product-reaction-deleted', deletedAccProductReaction);
    },
  },
};
</script>
